define('app/views/travel_checkout_view',['app/setup'],
  function(takhfifan) {
    var isPriceChanged = false;
    takhfifan.travelCheckout = Backbone.View.extend({
      events: {
        'change input[type=radio]': 'changeNation',
        'submit .tkh-travel-passenger-form' : 'submitForm',
        'click .tkh-travel-checkout__action-edit': 'enablePassengerForm',
        'click .tkh-payment-item': 'selectPaymentMethod',
        'click .tkh-travel-checkout__action-pay': 'saveOrderConfirm'
      },

      template: ( $('#travel-checkout-cart').length > 0 ) ?
        _.template( $('#travel-checkout-cart').html() ) : '',

      initialize: function () {
        this.captchaPath = this.$el.data('captchaUrl');
        this.saveOrderPath = this.$el.data('saveOrderUrl');
        this.paymentMethodsPath = this.$el.data('paymentMethodsUrl');
        this.savePaymentMethodsPath = this.$el.data('savePaymentMethodsUrl');

        takhfifan.eventHub.on('travel:goToPay', function () {
          this.saveOrder();
        }, this);
        takhfifan.eventHub.on('travel:back', function () {
          this.backToSearch();
        }, this);

        // takhfifan.eventHub.on('travel:addToCart', function () {
        //   this.initForm();
        // }, this);
        //
        takhfifan.eventHub.on('travel:viewChanged', function (options) {
          if(options.view==="cart"){
            this.initForm();
          }
        }, this);

        $(document).on('change invalid','.tkh-travel-form-input', function() {
          if($(this).prop('type')==='radio'){
            return;
          }
          var inputField = $(this).get(0);

          inputField.setCustomValidity('');

          if (!inputField.validity.valid) {
            var fieldName = $(this).prop('placeholder');
            inputField.setCustomValidity('لطفا ' + fieldName + ' را وارد کنید');
          }
        });
        $(".travel-price-confirm-modal__apply").on("click", function () {
          takhfifan.eventHub.trigger('travel:goToPay')
        });
        $(".travel-price-confirm-modal__cancel").on("click", function () {
          takhfifan.eventHub.trigger('travel:back')
        });
      },

      initForm: function () {
        var _this = this;
        this.searchTime = Lockr.get("travelSearchTime");
        if(!this.searchTime){
          this.showFailedCart('لطفا مجددا جستجو کنید');
        }else{
          this.flightModel = Lockr.get("travelFlightModel");
          this.searchInfo = Lockr.get("travelFlightSearchModel");
          var timeRemaining = new Date(this.searchTime) - new Date() + 900000;
          if(!takhfifan.travelSearchTimeOut){
            takhfifan.travelSearchTimeOut = setTimeout(function(){
              takhfifan.eventHub.trigger('message:show', {
                type: 'error',
                msg: 'مدت اعتبار جستجو تمام شد، لطفا مجددا جستجو کنید'
              });
              takhfifan.eventHub.trigger('travel:flightReset', _this.searchInfo);
            }, timeRemaining);
          }
          if(!this.flightModel || !this.searchInfo){
            this.showFailedCart('لطفا مجددا جستجو کنید');
          }else{
            this.getCaptcha();
          }
        }
      },

      showFailedCart: function(message){
        this.$el.html(this.template({message:message}));
      },

      getCaptcha: function(){
        var _this = this;
        $.ajax({
          type: 'GET',
          data: {
            id: this.flightModel.departure.id,
            searchId: this.flightModel.departure.searchId,
            date: this.flightModel.departure.date
          },
          url: _this.captchaPath
        }).done(function (data) {
          takhfifan.eventHub.trigger('travel:enable');
          if(data.code == 1){
            _this.captchaID = data.data.captchaID;
            _this.render(data.data.base64);
          }
        }).fail(function () {
          takhfifan.eventHub.trigger('travel:enable');
          _this.showFailedCart('در برقراری ارتباط با سرور مشکلی پیش آمد. لطفا مجددا جستجو کنید');
        });
      },

      getPaymentMethods: function () {
        var _this = this;
        $.ajax({
          type: 'POST',
          url: _this.paymentMethodsPath,
          data: {form_key: takhfifan.formKey}
        }).done(function (data) {
          _this.initConfirmView(data);
        }).fail(function () {
          takhfifan.eventHub.trigger('message:show', {
            type: 'error',
            msg: 'عملیات با خطا مواجه شد.'
          });
          _this.showFailedCart('در برقراری ارتباط با سرور مشکلی پیش آمد. لطفا مجددا جستجو کنید');
        }).complete(function(){
          takhfifan.eventHub.trigger('travel:enable');
        });
      },

      formatDate: function(unix){
        var currentDate = new Date(unix);
        return (currentDate.getFullYear()+"-"+this.addLeadingZero(currentDate.getMonth() +1) +"-"+this.addLeadingZero(currentDate.getDate()));
      },
      addLeadingZero: function (n) {
        var s = "0"+n;
        return s.substr(s.length-2);
      },

      render:function (captcha) {
        this.searchInfo.totalPassengers = parseInt(this.searchInfo.adult,10) + parseInt(this.searchInfo.child,10) + parseInt(this.searchInfo.infant,10);
        this.$el.html(this.template({
          message: false,
          model:this.flightModel,
          captcha: captcha,
          passengers : {
            adult: this.searchInfo.adult,
            child: this.searchInfo.child,
            infant: this.searchInfo.infant,
            total : this.searchInfo.totalPassengers
          }
        }));

        this.enableDatePickers();
      },

      enableDatePickers: function () {
        var _this = this;
        $('.tkh-travel-form-input-dp').pDatepicker({
          initialValue: false,
          observer: false,
          format: 'YYYY/MM/DD',
          minDate: null,
          maxDate: new Date(),
          autoClose: true,
          onSelect: function(unix) {
            var selectedDate = this.model.state.selected,
              $placeHolder = $(this.model.inputElement),
              selectedDateText = _this.formatDate(unix);

            $placeHolder.html(selectedDate.year + "/" + selectedDate.month + "/" + selectedDate.date);
            $($placeHolder.data('alt')).val(selectedDateText);
            $placeHolder.addClass('travel-form-input-dp--has-value');
          }
        });

        $('.tkh-travel-form-input-dpp').pDatepicker({
          initialValue: false,
          observer: false,
          format: 'YYYY/MM/DD',
          minDate: new Date(),
          maxDate: null,
          autoClose: true,
          onSelect: function(unix) {
            var selectedDate = this.model.state.selected,
              $placeHolder = $(this.model.inputElement),
              selectedDateText = _this.formatDate(unix);

            $placeHolder.html(selectedDate.year + "/" + selectedDate.month + "/" + selectedDate.date);
            $($placeHolder.data('alt')).val(selectedDateText);
            $placeHolder.addClass('travel-form-input-dp--has-value');
          }
        });
      },

      changeNation: function (e) {
        var $target = $(e.target),
            $parent = $target.parents('.tkh-travel-checkout-passenger'),
            $wrapper = $parent.find('.tkh-travel-checkout-passenger__foreignPart');

        if($target.val() == 'foreign'){
          $wrapper.show();
          $wrapper.find('.tkh-travel-form-input').removeAttr("disabled")
        }else{
          $wrapper.hide();
          $wrapper.find('.tkh-travel-form-input').prop("disabled","disabled")
        }
      },

      showPriceChangedConfirm: function (message) {
        $('.travel-price-confirm-modal p').html(message);
        this.modalContainer = $('.modal');
        takhfifan.eventHub.trigger(
          'modal:showModalWithContent',
          {
            elementToOperate: this.modalContainer,
            elementToOperateContent: this.modalContainer,
            triggerElement: this.modalContainer,
            fadeTimeIn: 400,
          });
      },

      backToSearch: function () {
        $('.modal').hide();
        takhfifan.eventHub.trigger('modal:closeModalWithContent');
        window.location.replace('#travel_view/search');
      },

      submitForm: function (e) {
        takhfifan.eventHub.trigger('travel:disable');
        var formData = this.gatherPassengersData();
        var _this = this;
        $.ajax({
          type: 'POST',
          url: _this.saveOrderPath,
          data: formData
        }).done(function (data) {
          if (data.result == 'failed') {
            //TODO: check if it is caused by captcha
            takhfifan.eventHub.trigger('message:show', {
                type: 'error',
                msg: data.message
              });
              takhfifan.eventHub.trigger('travel:enable');
              _this.showFailedCart('در برقراری ارتباط با سرور مشکلی پیش آمد. لطفا مجددا جستجو کنید');
          } else {
            var oldPrice = _this.$('.tkh-travel-total-price').html();
            oldPrice = oldPrice.replace("،", "");
            oldPrice = parseInt(oldPrice) *10;//convert Toman To Rial
            if(data.total_price != oldPrice){
              isPriceChanged = true;
              _this.updateTotalPrice(data.total_price)
            }
            _this.disablePassengerForm();
            _this.getPaymentMethods();
          }
        }).fail(function () {
          takhfifan.eventHub.trigger('message:show', {
            type: 'error',
            msg: 'عملیات با خطا مواجه شد.'
          });
          _this.showFailedCart('در برقراری ارتباط با سرور مشکلی پیش آمد. لطفا مجددا جستجو کنید');
          takhfifan.eventHub.trigger('travel:enable');
        }).complete(function(){
          // takhfifan.eventHub.trigger('travel:enable');
        });

        e.preventDefault();
        takhfifan.eventHub.trigger('travel:disable');

      },

      updateTotalPrice: function (price) {
        var $priceEl = this.$('.tkh-travel-total-price');
        $priceEl.css({'color':'#ff5a5f','font-weight':'bold'});
        $priceEl.html(formatPrice(price));
        $priceEl.parents('table').addClass('travel-checkout-list__price-table--updated');
        this.alertNewPrice(formatPrice(price),false);
      },

      disablePassengerForm : function () {
        var $form = $('.tkh-travel-passenger-form');
        $form.find(':input').each(function(){
          $(this).prop("disabled","disabled");
        });
        $('.datepicker-container').addClass('force-hide');
        this.$('.tkh-travel-checkout__action-policy').hide();
        this.$('.tkh-travel-checkout__action-back').hide();
        this.$('.tkh-travel-checkout__captcha').hide();
        this.$('.tkh-travel-checkout__action-submit').hide();
        this.$('.tkh-travel-checkout__action-edit').show();
        this.$('.tkh-travel-checkout__action-pay').show();
      },

      enablePassengerForm: function () {
        takhfifan.eventHub.trigger('travel:disable');
        this.getCaptcha();
        var $form = $('.tkh-travel-passenger-form');
        $form.find(':input').each(function(){
          $(this).removeAttr("disabled");
        });
        $('.datepicker-container').removeClass('force-hide');
        this.$('.tkh-travel-checkout__action-policy').show();
        this.$('.tkh-travel-checkout__action-edit').hide();
        this.$('.tkh-travel-checkout__action-pay').hide();
        this.$('.tkh-travel-checkout__action-back').show();
        this.$('.tkh-travel-checkout__action-submit').show();
        this.$('.tkh-travel-checkout__captcha').show();
        this.$('.tkh-travel-checkout__payments').html('');
        this.paymentMethod = "";
      },

      gatherPassengersData: function () {
        var _this = this,
        data = {
          departure : {
            captchaID: _this.captchaID,
            passengersCount: this.searchInfo.totalPassengers,
            airline: this.flightModel.departure.airline,
            from: this.flightModel.departure.from,
            to: this.flightModel.departure.to,
            flightNumber: this.flightModel.departure.flightNumber,
            class: this.flightModel.departure.class,
            bTypeE: this.flightModel.departure.bTypeE,
            departureDatetime: this.flightModel.departure.tmpDepTime
          }
        };

        if(this.flightModel.returnData){
          data.return = {
            captchaID: _this.captchaID,
            passengersCount: this.searchInfo.totalPassengers,
            airline: this.flightModel.returnData.airline,
            from: this.flightModel.returnData.from,
            to: this.flightModel.returnData.to,
            flightNumber: this.flightModel.returnData.flightNumber,
            class: this.flightModel.returnData.class,
            bTypeE: this.flightModel.returnData.bTypeE
          }
        }
        data['formKey'] = takhfifan.formKey;
        data['cellphoneNumber'] = this.$('input[name="cellphoneNumber"]').val();
        data['email'] = this.$('input[name="email"]').val();
        data['captcha'] = this.$('input[name="captcha"]').val();

        data['passengers'] = {};
        this.$('.tkh-travel-checkout-passenger').each(function (index) {
          var $pData = $(this);
          var birth = [
              parseInt($pData.find('[name="birth_year"]').val(),10),
              parseInt($pData.find('[name="birth_month"]').val(),10),
              parseInt($pData.find('[name="birth_day"]').val(),10)
            ],
            birthDay = new persianDate(birth);

          birthDay.toCalendar('gregorian');
          data['passengers'][index+1] = {
            "nationality": $pData.find('[name|="nationality"]:checked').val(),
            "pGender": $pData.find('[name="pGender"]').val(),
            "meliCode": $pData.find('[name="meliCode"]').val(),
            "FirstName": $pData.find('[name="FirstName"]').val(),
            "LastName": $pData.find('[name="LastName"]').val(),
            "FirstNameE": $pData.find('[name="FirstNameE"]').val(),
            "LastNameE": $pData.find('[name="LastNameE"]').val(),
            "exPass": $pData.find('[name="exPass"]').val(),
            "passNumber": $pData.find('[name="passNumber"]').val(),
            "pType": $pData.find('[name="pType"]').val(),
            // "birthday": $pData.find('[name="birthday"]').val(),
            "birthday": birthDay.toLocale('en').format("YYYY-MM-DD"),
            "nationalityId": $pData.find('[name="nationalityId"]').val()
          }
        });

        return data;
      },

      initConfirmView:function (paymentMethods) {
        var template = _.template($("#travel-payment-methods").html()),
          compiled_template = template({payment_methods:paymentMethods});
        $('.tkh-travel-checkout__payments').html(compiled_template);
        var $firstMethod = $('.tkh-travel-checkout__payments .tkh-payment-item').first();
        $firstMethod.addClass('active');
        this.savePaymentMethod($firstMethod.data("method"), true);
      },

      selectPaymentMethod: function(e) {
        var $target = $(e.currentTarget);
        $target.parent('.tkh-travel-checkout__payments').find('.active').removeClass('active');
        $target.addClass('active');
        this.savePaymentMethod($target.data("method"))
      },

      savePaymentMethod: function (method, isFirstTime) {
        var _this = this;
        isFirstTime = isFirstTime || false;

        this.$('.tkh-travel-checkout__action-pay').prop('disabled','disabled');
        $.ajax({
          type: 'POST',
          url: this.savePaymentMethodsPath,
          data: {
            form_key: takhfifan.formKey,
            payment: {
              method: method
            }
          }
        }).done(function(data) {
          _this.paymentMethod = method;
          if(!data.error){
            _this.$('.tkh-travel-checkout__action-pay').removeAttr('disabled');
          }else{
            takhfifan.eventHub.trigger('message:show', {
              type: 'error',
              msg: 'خطا در ثبت درگاه پرداخت، درگاه پرداخت را انتخاب کنید'
            });
          }
        }).fail(function (data) {
          if(isFirstTime){
            _this.savePaymentMethod.call(_this, method, false);
          }else{
            takhfifan.eventHub.trigger('message:show', {
              type: 'error',
              msg: 'خطا در ثبت درگاه پرداخت، درگاه پرداخت را انتخاب کنید'
            });
          }
        });
      },

      alertNewPrice: function (price, confirm) {
        var message = i18n.t('price_changed_new_price') + price;
        if (confirm) {
          this.showPriceChangedConfirm(message + '<br>' + i18n.t('continue_shopping'));
        } else {
          takhfifan.eventHub.trigger('message:show', {
            type: 'error',
            msg: message
          });
        }
      },

      saveOrderConfirm: function () {
        if (isPriceChanged) {
          var $priceEl = this.$('.tkh-travel-total-price');
          this.alertNewPrice(($priceEl.text()), true);
        } else {
          this.saveOrder();
        }
      },

      saveOrder: function () {
        takhfifan.eventHub.trigger('travel:disable');
        var _this = this;
        $.ajax({
          type: 'POST',
          //url: _this.saveOrderPath,
          url: '/ajax/onepage/saveOrder/',
          data: {
            form_key: takhfifan.formKey,
            payment: {
              method: this.paymentMethod
            }
           }
        }).done(function (data) {
          if(data.redirect){
            window.location.replace(data.redirect);
            Lockr.set("travelSearchTime","");
            Lockr.set("travelFlightModel","");
            Lockr.set("travelFlightSearchModel","");
          }else{
            takhfifan.eventHub.trigger('message:show', {
              type: 'error',
              msg: 'عملیات با خطا مواجه شد.'
            });
            _this.showFailedCart('در برقراری ارتباط با سرور مشکلی پیش آمد. لطفا مجددا جستجو کنید');
          }
        }).fail(function () {
          takhfifan.eventHub.trigger('message:show', {
            type: 'error',
            msg: 'عملیات با خطا مواجه شد.'
          });
          _this.showFailedCart('در برقراری ارتباط با سرور مشکلی پیش آمد. لطفا مجددا جستجو کنید');
        }).complete(function(){
          takhfifan.eventHub.trigger('travel:enable');
        });
      }

    })
  });

